// extracted by mini-css-extract-plugin
export default {"TasksList":"UFjuIHgOATdAl37H+Ds2sg==","Task":"fplfNOObI6pTubfYVjoU3g==","Title":"EyzGFWJ7W5T+0LiXmkx5Ag==","Visited":"EI4PDkXqr2B9SDV+OKQXYw==","Date":"_7tK0rJ+nTQGnrP73+b73Dw=="};